import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Search, Times } from 'common/images/FaIcons';
import { getPartnerPrimaryColor } from 'common/styles/organisationPartnerTheme';

// Brand accent, resolved per customer instead of a hard-coded green.
const primaryColor = theme => getPartnerPrimaryColor(theme);

// Self-contained search input for the org/site breadcrumb dropdowns. The shared
// InputField has layout quirks (fixed inner widths, forced margins) that make it
// awkward here, so this is a small, comfortably-sized field with a clear button.
const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 10px;
  padding: 5px 8px;
  border: 1px solid ${props => props.theme.colors.greyL};
  border-radius: 5px;
  background: ${props => props.theme.colors.white};
  transition: border-color 0.12s ease;

  .lead-icon {
    color: ${props => props.theme.colors.greyD};
    font-size: 11px;
    flex-shrink: 0;
  }

  &:focus-within {
    border-color: ${props => primaryColor(props.theme)};
  }
`;

const Field = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-family: 'Petasense Open Sans';
  color: ${props => props.theme.colors.greyXXD};

  &::placeholder {
    color: ${props => props.theme.colors.greyD};
  }
`;

const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: ${props => props.theme.colors.greyD};
  font-size: 11px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: ${props => props.theme.colors.greyXXD};
  }
`;

const BreadcrumbSearch = ({ value, onChange, onClear, placeholder, autoFocus }) => (
  <Wrap>
    <Search className="lead-icon" />
    <Field
      type="text"
      value={value}
      placeholder={placeholder}
      autoFocus={autoFocus}
      onChange={e => onChange(e.target.value)}
    />
    {value ? (
      <ClearButton type="button" onClick={onClear} aria-label="clear search">
        <Times />
      </ClearButton>
    ) : null}
  </Wrap>
);

BreadcrumbSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool
};

BreadcrumbSearch.defaultProps = {
  value: '',
  placeholder: '',
  autoFocus: false
};

export default BreadcrumbSearch;
